// /*Breadcrumbs*/
// var fragment = document.createDocumentFragment();

// // Append desired element to the fragment:
// fragment.appendChild(document.getElementById('shopify-section-slideshow-collection-wedding'));

// // Append fragment to desired element:
// document.getElementById('breadcrumbs-wrapper').appendChild(fragment);



/*Breadcrumbs*/
var fragment = document.createDocumentFragment();
jQuery( document ).ready(function($) {
    //console.log( "ready!" );
  if($("#shopify-section-slideshow-collection-wedding").length){
    // Append desired element to the fragment:
    fragment.appendChild(document.getElementById('shopify-section-slideshow-collection-wedding'));
  }
  if($("#breadcrumbs-wrapper").length){
    // Append fragment to desired element:
    document.getElementById('breadcrumbs-wrapper').appendChild(fragment);
  }



  });